import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import MyDataTable from "../../component/MyDataTable";
import { getDateDiff, getPartWarranty } from "../../utils/HelperFunction";
import WarehouseReverse from "./WarehouseReverse";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { EMPLOYEE_TYPE } from "../../constant/status_constant";

const DefectiveChallanGenerate = ({ setReverseReload }) => {
  let loggedInUser = useSelector((state) => state.authReducer.currentUser);
  const [reloadList, setReload] = useState(true);
  const [isOpenForm, setOpenForm] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ UNIQUE KEY FIX
  const getRowKey = (row) => `${row.id}_${row.booking_detail.id}`;

  // ✅ HANDLE ROW SELECTION
  const handleRowSelection = (event, row) => {
    const isChecked = event.target.checked;
    const currentScId = row.sc_id;
    const key = getRowKey(row);

    setSelectedRows((prev) => {
      if (isChecked) {
        if (prev.length > 0 && prev[0].sc_id !== currentScId) {
          toast.error(
            "Cannot select items from different service centers. Please uncheck previous selections.",
          );
          return prev;
        }

        return [...prev, { ...row, _key: key }];
      } else {
        return prev.filter((r) => r._key !== key);
      }
    });
  };

  // ✅ TOTAL SHIPPED QUANTITY
  const totalQty = selectedRows.reduce(
    (sum, item) => sum + (item.shipped_quantity || 0),
    0,
  );

  // ✅ HANDLE CREATE CHALLAN
  const handleCreateChallan = () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one row");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setOpenForm(true);
      setLoading(false);
    }, 300);
  };

  const closeForm = () => {
    setOpenForm(false);
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: <div className="word-wrap">ASC Name</div>,
      selector: (row) => row?.service_centre?.display_name || "N/A",
      wrap: true,
    },
    {
      name: <div className="word-wrap">Part Requested ID</div>,
      selector: (row) => row.id,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Booking ID</div>,
      selector: (row) => row.booking_detail.booking_id,
      cell: (row) => (
        <NavLink to={`/getbookingdetails?bid=${btoa(row.booking_detail.id)}`}>
          {row.booking_detail.booking_id}
        </NavLink>
      ),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Customer Name</div>,
      selector: (row) => row.booking_detail.user_detail.customer_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Appliance / Brand</div>,
      selector: (row) =>
        `${row.booking_detail.appliance.appliance_name} / ${row.booking_detail.user_appliance_detail.brand.brand_name}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Requested Part Name / Number</div>,
      selector: (row) =>
        `${row.requested_part.part_name} /  ${row.requested_part.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Shipped Part Name/ Number</div>,
      selector: (row) =>
        `${row.shipped_part.part_name} /  ${row.shipped_part.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Requested / Shipped Model Number</div>,
      selector: (row) =>
        `${row.requested_model.model_number} / ${row.shipped_model.model_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Serial Number</div>,
      selector: (row) =>
        row.booking_detail.user_appliance_detail.sf_serial_number,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Consumption</div>,
      selector: (row) => row.consumption_status?.status || "Part Not Consumed",
      wrap: true,
    },
    {
      name: <div className="word-wrap">Warranty Status</div>,
      selector: (row) => getPartWarranty(row.warranty_status),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Quantity</div>,
      selector: (row) => row.shipped_quantity,
      wrap: true,
    },
    {
      name: "Age",
      selector: (row) =>
        `${getDateDiff(row.booking_detail.sc_closed_date || row.forward_part_ack_date)} days`,
      wrap: true,
    },
    {
      name: "Create",
      cell: (row) => (
        <input
          type="checkbox"
          className="booking-selection-checkbox"
          checked={selectedRows.some((r) => r._key === getRowKey(row))}
          onChange={(e) => handleRowSelection(e, row)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    Reverse Challan To be Generated
                  </h3>
                </div>
                <MyDataTable
                  reloadList={reloadList}
                  columns={columns}
                  getDataListURL={`getdefectivetobeshppementlist?isdefective=1`}
                  setReload={setReload}
                  exportName={"partordered"}
                />
              </div>
            </div>
          </div>

          {/* ✅ SUMMARY BAR */}
          {selectedRows.length > 0 && (
            <div className="booking-summary-bar">
              <span className="booking-summary-label">
                Selected Items:
                <span className="booking-summary-count">
                  {selectedRows.length}
                </span>
              </span>

              <button
                type="button"
                className="booking-summary-btn"
                onClick={handleCreateChallan}
                disabled={loading}
              >
                {loading ? "Loading..." : `Create Challan`}
              </button>
            </div>
          )}
        </div>
      </section>

      {isOpenForm && (
        <WarehouseReverse
          closeForm={() => setOpenForm(false)}
          setReload={setReload}
          selectedRows={selectedRows}
          setEditRow={setSelectedRows}
          setReverseReload={setReverseReload}
        />
      )}
    </div>
  );
};

export default DefectiveChallanGenerate;
